import axios from 'axios';
import {Bill, BillSearchResponse} from '../../interfaces/bill';
import {Systems} from '../../interfaces/systems';
import {isClientCIS} from "../../common/tools/client";

export const getLastBills = async (count?: number) => {
    const url = count !== undefined ? `/api/billing/bills/lasts/${count}` : `/api/billing/bills/lasts`;
    const response = await axios.get<BillSearchResponse[]>(url);
    return response.data;
};

export const getReclamationBills = async () => {
    const response = await axios.get<Bill[]>('/api/reclamation/bills');
    return response.data;
};

//@todo à supprimer quand il y aura une vraie authentification
export const getSystem = (clientId: string): Systems => {
    return isClientCIS(clientId) ? Systems.CIS : Systems.DESK;
};

export const getG2000Link = async (ficheId: string, user: string): Promise<string> => {
   const r = await axios.post<{link: string}>('/api/g2000/link',  {
       ficheId : ficheId,
       user : user
   });
   return r.data.link;
};
